export const OPEN_FEEDBACK_EVENT = "denker:open-feedback";
